import usePrivateAxios from '@/common/api/usePrivateAxios'
import { Mapper } from '@/common/services/mapper'
import { useQuery } from '@tanstack/react-query'

interface UseTmaisBadgeProps<T> {
  id?: string
  mapper?: (data: any) => T
  enabled?: boolean
}

export const useTmaisBadge = <T,>({ id, mapper = Mapper.default<T>(), enabled = true }: UseTmaisBadgeProps<T>) => {
  const privateAxios = usePrivateAxios()

  return useQuery({
    queryKey: ['tmaisBadge', id],
    queryFn: () => privateAxios.get(`/tmais/badges/${id}`),
    select: (response: { data: { data: any } }) => mapper(response?.data?.data),
    enabled: Boolean(id) && enabled,
  })
}
